import React, { useRef, useState, useCallback, useEffect } from "react";
import { Modal, Form, Row, Col, Select, Input } from "antd";
import { connect } from "dva";
import { HardRouteLocation, HardRouteLocationMap, RouteReasonMap } from "@/utils/enum";

const { Option } = Select;
const { TextArea } = Input;

const HardRouteModal = ({
  adminShipmentView,
  dispatch,
  visible,
  hardRouteLocation: propHardRouteLocation,
  onClose,
}) => {
  const formRef = useRef();

  const [loading, setLoading] = useState(false);
  const [hardRouteLocation, setHardRouteLocation] = useState(HardRouteLocation.NormalRoute);

  const handleSetHardRoute = useCallback(() => {
    const adminShipmentData = adminShipmentView.data;

    formRef.current.validateFields().then(data => {
      setLoading(true);

      dispatch({
        type: "adminShipmentView/setHardRoute",
        shipmentId: adminShipmentData.id,
        location: data.location,
        note: data.note,
        reason: data.reason,
      }).then(res => {
        setLoading(false);
        formRef.current.resetFields();

        if (typeof onClose === "function") {
          onClose(res.hardRouteLocation);
        }
      });
    });
  }, [adminShipmentView]);

  const onCancel = useCallback(() => {
    formRef.current.resetFields();

    if (typeof onClose === "function") {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (visible) {
      setHardRouteLocation(propHardRouteLocation);
      formRef.current.setFieldsValue({
        location: propHardRouteLocation,
      });
    }
  }, [visible, propHardRouteLocation]);

  return (
    <Modal title="Hard route" visible={visible} onOk={handleSetHardRoute} onCancel={onCancel} confirmLoading={loading}>
      <Form ref={formRef}>
        <Row gutter={16}>
          <Col flex={1}>
            <Form.Item name="location" label="Which location has a hard route?" rules={[{ required: true }]}>
              <Select
                placeholder="Location"
                style={{ width: "100%" }}
                value={hardRouteLocation}
                onChange={value => {
                  setHardRouteLocation(value);

                  if (value === HardRouteLocation.NormalRoute) {
                    formRef.current.setFieldsValue({
                      reason: null,
                    });
                  }
                }}
              >
                {Object.entries(HardRouteLocationMap).map(([key, label]) => (
                  <Option key={Number(key)} value={Number(key)}>
                    {label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="reason"
              label="Reason"
              rules={[
                {
                  required: hardRouteLocation !== HardRouteLocation.NormalRoute,
                },
              ]}
              style={{
                marginLeft: hardRouteLocation !== HardRouteLocation.NormalRoute ? 0 : 11,
              }}
            >
              <Select
                placeholder="Reason"
                disabled={hardRouteLocation === HardRouteLocation.NormalRoute}
                style={{ width: "100%" }}
              >
                {Object.entries(RouteReasonMap).map(([key, label]) => (
                  <Option key={Number(key)} value={Number(key)}>
                    {label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="note" label="Note" rules={[{ required: true, message: "Please enter note" }]}>
              <TextArea rows={4} placeholder="Additional notes" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default connect(({ adminShipmentView }) => ({
  adminShipmentView,
}))(HardRouteModal);
